export default function vodafoneCustomLoader({ src, width, quality }) {
  return `${src}?w=${width}&q=${quality}`;
}
